import { useNavigate } from 'react-router-dom';

import { Stack, Button, useTheme, Typography } from '@mui/material';

import { Routes } from 'src/shared/model/routes';
import { LogoIcon, ProgramIcon } from 'src/shared/components/icons';

const clearRuntimeCaches = async () => {
  if (!('caches' in window)) return;

  const cacheNames = await caches.keys();
  await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
};

const updateServiceWorkers = async () => {
  if (!('serviceWorker' in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.update()));
};

const onApplyUpdate = async () => {
  await Promise.all([clearRuntimeCaches(), updateServiceWorkers()]);
  window.location.reload();
};

interface Props {
  showUpdateCTA?: boolean;
}

export default function Page({ showUpdateCTA = false }: Props) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack
      gap={5}
      alignItems="center"
      px="18px"
      pt={`max(${theme.tg.saveContentTop}, 10px)`}
      sx={(muiTheme) => ({
        width: '100%',
        boxSizing: 'border-box',
        [muiTheme.breakpoints.up('md')]: {
          maxWidth: 480,
          mx: 'auto',
        },
      })}
    >
      <LogoIcon
        sx={{
          width: { xs: '200px', md: '300px' },
          height: 'auto',
          maxWidth: '100%',
        }}
      />
      <ProgramIcon
        sx={{
          width: 80,
          height: 80,
        }}
      />
      <Stack gap="24px">
        <Typography
          fontWeight={600}
          fontSize={{ xs: '20px', md: '24px' }}
          align="center"
          color="blue.light"
          variant="h3"
        >
          Произошла непредвиденная ошибка
        </Typography>
        <Typography
          fontWeight={500}
          fontSize={{ xs: '18px', md: '22px' }}
          align="center"
          color="blue.light"
        >
          {showUpdateCTA
            ? 'Похоже, доступна новая версия. Обновите приложение, чтобы продолжить работу.'
            : 'Пожалуйста, перезагрузите страницу или обратитесь в поддержку'}
        </Typography>
        {showUpdateCTA ? (
          <Button onClick={() => void onApplyUpdate()} variant="contained">
            Обновить приложение
          </Button>
        ) : (
          <Button onClick={() => navigate(Routes.Main)} variant="contained">
            Вернуться на главную
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
